import clsx from 'clsx';
import {FC} from 'react';
import {t} from 'ttag';

import useSessionTimer from '../../hooks/useSessionTimer';
import BackButton from '../BackButton';
import LoggedInMenu from './LoggedInMenu';

type LoggedInHeaderProps = {
    backLabel?: string;
    backUrl?: string;
    className?: string;
    email: string;
    sessionExpiration: number;
};

const LoggedInHeader: FC<LoggedInHeaderProps> = ({
    backLabel = '',
    backUrl = '/portal',
    className,
    email,
    sessionExpiration,
}) => {
    const sessionStatus = useSessionTimer(sessionExpiration);

    return (
        <div className={clsx('mt-6 flex justify-between', className)}>
            <div>
                <BackButton
                    backUrl={backUrl}
                    label={backLabel || t`Return to List of Business Portals`}
                />
            </div>
            <LoggedInMenu email={email} sessionStatus={sessionStatus} />
        </div>
    );
};

export default LoggedInHeader;
